import {Observable} from 'rxjs';
import {filter} from 'rxjs/operators';

import UiEventType            from '../../../../Ui/Shared/Constants/UiEventType';
import IUiEventsStreamPayload from '../../../../Ui/Shared/Interfaces/IUiEventsStreamPayload';

const createCaptionsOptionTapStream = (
    uiEvents$: Observable<IUiEventsStreamPayload>
): Observable<IUiEventsStreamPayload> =>
    uiEvents$
        .pipe(
            filter(({type}) => type === UiEventType.CAPTIONS_OPTION_TAP)
        );

export default createCaptionsOptionTapStream;